<template>
  <header>
    <div class="container">
      <div class="image" :style="{ backgroundImage: 'url(' + featuredImage + ')' }">
      </div>
      <section class="extraHeader">
        <h1 v-html="extra.title"></h1>
        <div>
          <p class="meta">
            <span>{{ formattedPubDate }}</span>
            <a href="#comments">{{ comments }} Comments</a>
          </p>
          <p class="actions">
            <span>Share
              <a target="_blank" :href="'https://twitter.com/home?status=' + encodeURI(extra.permalink)" class="icon">
                <iconify-icon icon="fa6-brands:twitter" />
                <span class="sr-only">Twitter</span>
              </a>
              <a target="_blank" :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(extra.permalink)" class="icon">
                <iconify-icon icon="fa6-brands:facebook-f" />
                <span class="sr-only">Facebook</span>
              </a>
            </span>
          </p>
        </div>
      </section>
    </div>
  </header>
</template>

<script>
export default {
  name: 'hero',
  props: ['extra', 'comments'],
  computed: {
    formattedPubDate () {
      let vm = this
      return vm.$moment(vm.extra.date).format('MM.DD.YY')
    },
    featuredImage () {
      let vm = this
      let image = vm.extra.image.large
      if (process.env.NODE_ENV === 'development') {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content')
      }
      return image
    }
  }
}
</script>

<style lang="sass" scoped>
@import ../../assets/styles/colors
@import ../../assets/styles/mixins

header
  +tablet
    margin-bottom: -36px
  .container
    +smDesktop
      display: flex
      align-items: flex-end
    +desktop
      align-items: center
    .image
      background-size: cover
      background-position: 50% 0
      margin-right: 85px
      position: relative
      display: flex
      align-items: center
      justify-content: center
      width: 100%
      height: 0
      padding-bottom: 60%
      +tablet
        justify-content: flex-end
      +smDesktop
        width: 548px
        height: calc(548px * 0.6)
        padding-bottom: 0
      +desktop
        width: 636px
        height: calc(636px * 0.6)

    .extraHeader
      flex: 1
      position: relative
      +smDesktop
        padding-left: 0
        padding-right: 30px
      +desktop
        padding-left: 30px
        padding-right: 0
      h1
        font-size: 36px
        font-weight: bold
        margin-bottom: 0
        line-height: 38px
        margin-top: 60px
        margin-bottom: 15px
        +tablet
          display: flex
          align-items: center
          margin-top: 90px
          margin-bottom: 20px
        +smDesktop
          margin-top: 50px
      > div
        font-weight: bold
        width: 100%
        +smDesktop          
          padding-right: 30px
          margin-top: 4px
        +desktop
          position: absolute
          padding-right: 0
          padding-left: 30px
          right: 0
        .meta, .actions
          display: flex
          justify-content: space-between
          font-size: 18px
          margin: 0
          padding: 7px 0
          letter-spacing: 0.5px
          +tablet
            padding: 7px 0
        .meta a
          color: inherit
          &:hover
            color: lighten($textColor, 25%)
        .actions
          border-top: 1px solid #95989A
          border-bottom: 1px solid #95989A
          font-size: 16px
          > a
            color: inherit
            &:hover
              svg path
                fill: $textColor
          .icon
            margin-left: 3px


</style>



// WEBPACK FOOTER //
// Hero.vue?7383ccf8